module.exports = __webpack_public_path__ + "static/warlock_of_the_fiend-71ad0b5701dbd42215e4e4331a7ed13f.jpeg";